module.exports = __webpack_public_path__ + "assets/bathtub-icon.08a70ad4.svg";